import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'
import { EditQuotationPage } from '../../../../features/sales/quotation-pages'

export const Route = createFileRoute('/_app/quotations/$quotationId/edit')({
  staticData: { crumb: 'quotationEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'quotations.create'),
  loader: ({ context }) => context.queryClient.ensureQueryData(taxRatesQueryOptions),
  component: EditQuotationPage,
})
